import { setCanvasProperty } from "../base/canvas";
import { CLEAR_ROOM } from "../base/conference";
import { ReducerRegistry, StateListenerRegistry } from "../base/redux";
import { SET_PROPERTY, SET_LAYOUT_STYLE_PROPERTY, SET_REMOTE_PARTICIPANTS, SET_VIDEO_LAYOUT_MODE, SET_VISIBLE_REMOTE_COUNTS, SET_IS_DUALMONITOR } from "./actionType";
import { documentLayoutList, videoLayoutMode } from "./constants";
import { getCurrentMode } from "./functions";

const DEFAULT_STATE = {
    isDualMonitor: false,
    mode: videoLayoutMode.default,
    viewVisible: {
        [videoLayoutMode.screen]: false,
        [videoLayoutMode.vod]: false,
        [videoLayoutMode.white]: false,
        [videoLayoutMode.document]: false,
        [videoLayoutMode.note]: false
    },
    layoutWidth: 0,
    layoutHeight: 0,
    prevDocumentMode: videoLayoutMode.document,
    prevLayoutMode: videoLayoutMode.grid,
    screenModal: false,    
    remoteParticipants: [],
    visibleParticipantsCount: 0,
    visibleRemoteParticipants: new Set(),    
    gridCount: 10,
    page: 1,
    isShowArrow: {
        prev: false,
        next: false,
        maxPage: 1
    }, 
    includePin: true
};

ReducerRegistry.register("features/video-layout-mode", (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_VIDEO_LAYOUT_MODE:
            const { mode } = action;

            return {
                ...state,
                mode,
                viewVisible: {
                    [videoLayoutMode.screen]: mode === videoLayoutMode.screen ? true : false,
                    [videoLayoutMode.vod]: mode === videoLayoutMode.vod ? true : false,
                    [videoLayoutMode.white]: mode === videoLayoutMode.white ? true : false,
                    [videoLayoutMode.document]: mode === videoLayoutMode.document ? true : false,
                    [videoLayoutMode.note]: mode === videoLayoutMode.note ? true : false
                }
            }
        
        case SET_REMOTE_PARTICIPANTS: {
            state.remoteParticipants = action.participants;
            const { visibleParticipantsCount, page } = state;

            const startIndex = visibleParticipantsCount * (page - 1);
            
            state.visibleRemoteParticipants = new Set(state.remoteParticipants.slice(
                startIndex, startIndex + visibleParticipantsCount)
            );
            
            return { ...state };
        }

        case SET_VISIBLE_REMOTE_COUNTS: {
            return {
                ...state,
                visibleParticipantsCount: action.count
            }
        }

        case SET_LAYOUT_STYLE_PROPERTY: {
            return {
                ...state,
                layoutWidth: action.width,
                layoutHeight: action.height
            }
        }
        
        case SET_PROPERTY: {
            return {
                ...state,
                ...action.data
            }
        }

        case CLEAR_ROOM:
            return {
                ...DEFAULT_STATE,
                mode: state.mode,
                prevDocumentMode: videoLayoutMode.document,
                prevLayoutMode: videoLayoutMode.grid,
                viewVisible: state.viewVisible,
                layoutWidth: state.layoutWidth,
                layoutHeight: state.layoutHeight,
                isDualMonitor: false,
            };
    }
    return state;
});

StateListenerRegistry.register(state => getCurrentMode(state),
    (mode, store, prevMode) => {
        if (documentLayoutList.indexOf(mode) !== -1) {
            store.dispatch(setCanvasProperty({ zoom: 100, isWidthFit: undefined, showOption: false }));
        }
    });
